module.exports = __webpack_public_path__ + "img/shYh.27fa01c0.png";